import { PaymentListCell } from "./PaymentListCell";
import { PractitionerCell } from "./PractitionerCell";
import { PatientCell } from "./PatientCell";

export { PaymentListCell, PractitionerCell, PatientCell };


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/Cell/index.js